
export const formatRupiah = (value) => {
  if (value === null || value === undefined) return "Rp 0";
  return `Rp ${Number(value).toLocaleString("id-ID")}`;
};

export const formatPercent = (value) => {
  if (value === null || value === undefined) return "0%";

  const num = Number(value);

  if (num === 0) return "0%";

  return `${(num * 100).toFixed(2)}%`;
};

export const configMonthToDateBranch = [
  {
    name: "branchName",
    label: "\n",
    options: { sort: false },
  },
  {
    name: "lastMonthValue",
    label: "Last Month",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
  {
    name: "thisMonthValue",
    label: "This Month",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
  {
    name: "growthPercent",
    label: "Growth",
    options: {
      sort: false,
      customBodyRender: formatPercent,
    },
  },
  {
    name: "projectionSales",
    label: "Proyeksi",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
];
